import React from "react";
import { Document, Page, Text, View, Font, StyleSheet } from "@react-pdf/renderer";
Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        //border: "1px solid black",
    }
});

const LectureTakenDoc = ({ lecturedata }) => {

    const lecturelist = Array.isArray(lecturedata?.data) ? lecturedata.data : [];

    const courseName = lecturelist.length > 0 ? lecturelist[0].Course_Name : '';
    const batchCode = lecturelist.length > 0 ? lecturelist[0].Batch_code : '';
    function formatDate(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');        // dd
        const month = String(date.getMonth() + 1).padStart(2, '0'); // mm (months are 0-indexed)
        const year = date.getFullYear();                            // yyyy

        return `${day}-${month}-${year}`;
    }
    return (
        <Document>
            <Page size="A4" style={{ padding: 10, fontSize: 8 }}>

                <View style={[styles.header, { fontSize: "9px" }]}>
                    <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>Suvidya Institute of Technology Pvt. Ltd.</Text>
                </View>
                <View style={[styles.row, { marginBottom: "2%", border: "1px solid black", fontSize: "9px", textAlign: "center", width: '100%' }]}>
                    <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>Lecture Details</Text>
                </View>
                <View style={[styles.col]}>
                    <View style={[styles.row, { marginBottom: "2px", border: "1px solid black", fontSize: "9px", width: '100%' }]}>
                        <Text style={{ marginLeft: '5px' }}>Training Programme  :  {courseName}</Text>
                    </View>
                    <View style={[styles.row, { marginBottom: "2px", borderTop: "1px solid black", borderBottom: "1px solid black", borderRight: "1px solid black", fontSize: "9px", width: '100%' }]}>
                        <Text style={{ marginLeft: '5px' }}>Batch No. : {batchCode} </Text>
                    </View>
                </View>

                <View style={[styles.col, { border: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                    <View style={{ borderRight: "1px solid black", width: "7%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Lecture No.</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Date</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "25%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Lecture </Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "10%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Study Matl. Issued</Text>
                    </View>

                    <View style={{ borderRight: "1px solid black", width: "10%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>TAssignment / Test</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "13%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Faculty</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Planned Duration</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Actual Duration</Text>
                    </View>
                    <View style={{ width: "18%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins", fontWeight: "bold" }}>Topic Discussed</Text>
                    </View>

                </View>
                {lecturelist.map((item, index) => (
                    <View style={[styles.col, { borderBottom: "1px solid black", borderRight: "1px solid black", borderLeft: "1px solid black", fontSize: "8px", textAlign: "center", width: "100%" }]}>
                        <View style={{ borderRight: "1px solid black", width: "7%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>1</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Take_Dt}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "25%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Lecture_Name}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Material}</Text>
                        </View>

                        <View style={{ borderRight: "1px solid black", width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}> {item.Test_Given}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "13%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Faculty_Name} </Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Duration}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}> 5.00 Hrs.</Text>
                        </View>
                        <View style={{ width: "18%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8 }}>{item.Topic}</Text>
                        </View>

                    </View>
                ))}




            </Page>
        </Document>
    );
};

export default LectureTakenDoc;
